/**
 * Flow Status Value Object - Following GTD Pattern
 * Represents the status of a design-implementation coordination flow
 */
export class FlowStatus {
  private constructor(
    public readonly status: string,
    public readonly displayName: string,
    private readonly allowedTransitions: string[]
  ) {}

  static draft(): FlowStatus {
    return new FlowStatus('draft', 'Draft', ['active', 'abandoned']);
  }

  static active(): FlowStatus {
    return new FlowStatus('active', 'Active', ['completed', 'abandoned']);
  }

  static completed(): FlowStatus {
    return new FlowStatus('completed', 'Completed', []);
  }

  static abandoned(): FlowStatus {
    return new FlowStatus('abandoned', 'Abandoned', ['draft', 'active']);
  }

  static fromString(status: string): FlowStatus {
    switch (status) {
      case 'draft': return FlowStatus.draft();
      case 'active': return FlowStatus.active();
      case 'completed': return FlowStatus.completed();
      case 'abandoned': return FlowStatus.abandoned();
      default: throw new Error(`Invalid flow status: ${status}`);
    }
  }

  canTransitionTo(newStatus: string): boolean {
    return this.allowedTransitions.includes(newStatus);
  }

  isActive(): boolean {
    return this.status === 'active';
  }

  isCompleted(): boolean {
    return this.status === 'completed';
  }

  equals(other: FlowStatus): boolean {
    return this.status === other.status;
  }

  toString(): string {
    return this.status;
  }
}